import {
  ActionMenu,
  colors2,
  LoaderOverlay,
  ModalConfirm,
  PaddingTopBottom5,
  UI_BODY_SM_DF,
  WrapperCardGrid,
} from "oolib";
import React, { useState } from "react";

import { SidebarLayoutV2 } from "@/components/layout/SidebarLayoutV2";
import { useOutOfTheBoxForm } from "@/pageTpls/ContributeTpl/utils/useOutOfTheBoxForm";
import { formValidationCheckV2 } from "@/utils/validation/formValidation";
import { AddWidgetButton } from "./comps/AddWidgetButton";
import { WidgetRenderer } from "./comps/WidgetRenderer";
import {
  allWidgetsBaseConfs,
  GRID_GAP,
  sampleConfig,
  TOTAL_COLUMNS,
  widgetMetaConfigs,
} from "./CONFIG";
import { ButtonGhost, ButtonPrimary } from "oolib/dist/v2/components/Buttons";
import { useDeleteReport, usePublishReport, useViewReport } from "./queries";
import { useNavigate, useParams } from "react-router-dom";

const Padding16Px = ({ children }) => {
  return <div style={{ padding: "1.6rem" }}>{children}</div>;
};

const setContentFunction = ({
  setConfig,
  fnThatReturnsUpdatedWidgetConfig,
  underEditWidgetIdx,
}) => {
  setConfig((prev) => {
    const updatedWidgetConfig = fnThatReturnsUpdatedWidgetConfig(
      JSON.parse(JSON.stringify(prev[underEditWidgetIdx]))
    );
    const modifiedConfig = JSON.parse(JSON.stringify(prev));
    modifiedConfig[underEditWidgetIdx] = updatedWidgetConfig;
    return modifiedConfig;
  });
};

const WidgetConfigFormRenderer = ({
  underEditWidgetIdx,
  setUnderEditWidgetIdx,
  config,
  setConfig,
}) => {
  const { FORM, SUBMIT_BUTTON } = useOutOfTheBoxForm({
    FormWrapper: Padding16Px,
    blockWrapper: PaddingTopBottom5,
    onSubmit: () => setUnderEditWidgetIdx(undefined),
    content: config[underEditWidgetIdx],
    setContent: (fnThatReturnsUpdatedWidgetConfig) =>
      setContentFunction({
        setConfig,
        fnThatReturnsUpdatedWidgetConfig,
        underEditWidgetIdx,
      }),
    configs: widgetMetaConfigs[config[underEditWidgetIdx].comp],
  });
  return (
    <div>
      {FORM}
      <div style={{ padding: "0 16px" }}>{SUBMIT_BUTTON}</div>
    </div>
  );
};

export const ReportLanding = () => {
  const { mode, reportId } = useParams();
  const { data, status } = useViewReport({ reportId });

  return (
    <div>
      {status === "loading" ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "300px 1fr",
            gap: "0.8rem",
            height: "calc(100vh - 6rem)",
          }}
        >
          <WrapperCardGrid>
            {[1, 2, 3, 4, 5, 6].map((d) => (
              <div style={{ height: "30rem" }} />
            ))}
          </WrapperCardGrid>
        </div>
      ) : (
        status === "success" && <ReportMainPage data={data} />
      )}
    </div>
  );
};

const ReportMainPage = ({ data }) => {
  const [underEditWidgetIdx, setUnderEditWidgetIdx] = useState(undefined);
  const navigate = useNavigate();
  const [config, setConfig] = useState(data.config);

  const tempColors = {
    grid: "",
    item: "lightgrey",
  };

  const someRequiredPropsUnset = (item) => {
    const { failedBlocks } = formValidationCheckV2({
      blocks: widgetMetaConfigs[item.comp],
      content: item,
    });

    if (failedBlocks.length > 0) return true;
    //else
    return false;
  };

  const { mutate: publishReport, isLoading } = usePublishReport();
  const { mutate: deleteReport, deleteIsLoading } = useDeleteReport();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  return (
    <div>
      {isLoading && <LoaderOverlay loaderText="Publishing Report..."/>}
      {deleteIsLoading && <LoaderOverlay loaderText="Deleting Report..."/>}
      {showDeleteModal && (
        <ModalConfirm
          title="Are you sure you want to delete this report?"
          onClose={() => setShowDeleteModal(false)}
          onCloseText="No"
          onConfirmText="Yes, delete this report"
          onConfirm={() => {
            deleteReport({ reportId: data._id }, {
              onSuccess: () => {
                navigate('/reports')
              }
            });
          }}
        />
      )}
       {showExitModal && (
        <ModalConfirm
          title="All unsaved changes will be lost if you leave this page."
          subTitle="Are you sure you want to go back to all reports?"
          onClose={() => setShowExitModal(false)}
          onCloseText="No"
          onConfirmText="Yes, take me to all reports."
          onConfirm={() => {
            navigate('/reports');
          }}
        />
      )}
      <div
        style={{
          padding: "0.4rem 1rem",
          borderBottom: `1px solid ${colors2.grey10}`,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "0.8rem",
        }}
      >
        <UI_BODY_SM_DF>{data.title}</UI_BODY_SM_DF>
        <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
          <ButtonPrimary
            disabled={isLoading}
            onClick={() => {
              publishReport({
                reportId: data._id,
                config,
                title: data.title,
                subtitle: data.title,
              });
            }}
          >
            Publish
          </ButtonPrimary>
          <div style={{position: 'relative', zIndex: 10000 /** without the zindex it goes behind the action menu on the widgets */}}>
          <ActionMenu
          
            actions={[
              {
                display: "Delete",
                onClick: () => {
                  setShowDeleteModal(true);
                },
              },
              {
                display: "Back to all reports",
                onClick: () => {
                  setShowExitModal(true)
                },
              },
            ]}
          />
          </div>
        </div>
      </div>
      <SidebarLayoutV2
        gridHeightCSS="calc(100vh - 6rem)"
        toggleState={{
          lsb: underEditWidgetIdx !== undefined ? true : false,
          rsb: false,
        }}
        lsbWidth={300}
        lsbComp={
          <div>
            <div
              style={{
                padding: "0.8rem 1.6rem",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ButtonGhost
                icon="X"
                onClick={() => setUnderEditWidgetIdx(undefined)}
              />
            </div>
            {underEditWidgetIdx !== undefined && (
              <WidgetConfigFormRenderer
                key={config[underEditWidgetIdx].id}
                setUnderEditWidgetIdx={setUnderEditWidgetIdx}
                underEditWidgetIdx={underEditWidgetIdx}
                config={config}
                setConfig={setConfig}
              />
            )}
          </div>
        }
      >
        <div style={{ paddingLeft: 34 + GRID_GAP + "px" }}>
          <div
            style={{
              display: "grid",
              gap: GRID_GAP + "px",
              padding: "8px",
              background: tempColors.grid,
              /* Default size for auto-created columns */
              gridTemplateColumns: `repeat(${TOTAL_COLUMNS}, 1fr)` /* Create 12 equal columns */,
              /* Default size for auto-created rows */
              // gridAutoRows: 'minMax(0px, auto)',
              // gridAutoFlow: 'row dense'
            }}
          >
            {config.map((item, itemIdx) => {
              return (
                <WidgetRenderer
                  config={config}
                  setConfig={setConfig}
                  widgetConfig={item}
                  widgetIdx={itemIdx}
                  underEditWidgetIdx={underEditWidgetIdx}
                  setUnderEditWidgetIdx={setUnderEditWidgetIdx}
                />
              );
            })}
            <div
              style={{
                position: "relative",
                height: "34px",
                marginBottom: "10rem",
              }}
            >
              <AddWidgetButton
                {...{
                  config,
                  setConfig,
                  isNewRow: true,
                  setUnderEditWidgetIdx,
                }}
              />
            </div>
          </div>
        </div>
      </SidebarLayoutV2>
    </div>
  );
};
